import { debounce } from "lodash";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { actions, Form } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import * as NavigationActions from "../../../actions/navigation";
import * as TrialInstitutionLaboratoryActions from "../../../actions/trialInstitutionLaboratory";
import * as TrialInstitutionLaboratoryContractActions from "../../../actions/trialInstitutionLaboratoryContract";
import { NotificationAlert } from "../../../components/common/index";
import {
    DatePickerFormInputFabric,
    TextFormInput,
} from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { isUrl } from "../../../functions/string";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import {
    TrialInstitutionLaboratoryContractCreateBreadcrumbs,
    TrialInstitutionLaboratoryContractDetailsBreadcrumbs,
} from "../../../helpers/breadcrumbHelper";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import { TrialInstitutionLaboratoryContractSubMenu } from "../../../helpers/subMenuHelper";
import useNavigate from "../../../hooks/useNavigate";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import { ITrialInstitutionLaboratoryContractReduxFormState } from "../../../reducers/reactReduxForms/trialInstitutionLaboratoryContract";

import "./TrialInstitutionLaboratoryContractPage.scss";

interface TrialInstitutionLaboratoryContractPageProps {
    form: Dtos.TrialInstitutionLaboratoryContract & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITrialInstitutionLaboratoryContractReduxFormState;
    trialInstitutionLaboratoryContract: Dtos.TrialInstitutionLaboratoryContract;
    lookups: Dtos.Lookup[];
    loadingTrialInstitutionLaboratoryContract: boolean;
    loadTrialInstitutionLaboratoryContractSuccess: boolean;
    loadTrialInstitutionLaboratoryContractFailure: boolean;
    loadTrialInstitutionLaboratoryContractErrorCode: string;
    savingTrialInstitutionLaboratoryContract: boolean;
    saveTrialInstitutionLaboratoryContractSuccess: boolean;
    saveTrialInstitutionLaboratoryContractFailure: boolean;
    creatingTrialInstitutionLaboratoryContract: boolean;
    createTrialInstitutionLaboratoryContractSuccess: boolean;
    createTrialInstitutionLaboratoryContractFailure: boolean;
    validatingTrialInstitutionLaboratoryContract: boolean;
    validationFailures: Dtos.ResponseError[];
    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    trialInstitutionLaboratory: Dtos.TrialInstitutionLaboratory;
    loadingTrialInstitutionLaboratory: boolean;
    loadTrialInstitutionLaboratorySuccess: boolean;
    loadTrialInstitutionLaboratoryFailure: boolean;
    loadTrialInstitutionLaboratoryErrorCode: string;
    clearTrialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContractActions.ITrialInstitutionLaboratoryContractClearActionCreator;
    loadTrialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContractActions.ITrialInstitutionLaboratoryContractLoadByIdActionCreator;
    saveTrialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContractActions.ITrialInstitutionLaboratoryContractSaveActionCreator;
    createTrialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContractActions.ITrialInstitutionLaboratoryContractCreateActionCreator;
    validateTrialInstitutionLaboratoryContract: TrialInstitutionLaboratoryContractActions.ITrialInstitutionLaboratoryContractValidateActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
    loadTrialInstitutionLaboratory: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratoryLoadByIdActionCreator;
    clearTrialInstitutionLaboratory: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratoryClearActionCreator;
}

const reduxFormName: string = "reduxForms.trialInstitutionLaboratoryContract";

const TrialInstitutionLaboratoryContractPage: FC<TrialInstitutionLaboratoryContractPageProps> = ({
    form,
    formState,
    formProperties,
    trialInstitutionLaboratoryContract,
    lookups,
    loadingTrialInstitutionLaboratoryContract,
    loadTrialInstitutionLaboratoryContractFailure,
    loadTrialInstitutionLaboratoryContractErrorCode,
    savingTrialInstitutionLaboratoryContract,
    saveTrialInstitutionLaboratoryContractSuccess,
    saveTrialInstitutionLaboratoryContractFailure,
    creatingTrialInstitutionLaboratoryContract,
    validatingTrialInstitutionLaboratoryContract,
    validationFailures,
    permissions,
    trialInstitutionLaboratory,
    loadingTrialInstitutionLaboratory,
    loadTrialInstitutionLaboratoryFailure,
    loadTrialInstitutionLaboratoryErrorCode,
    clearTrialInstitutionLaboratoryContract,
    loadTrialInstitutionLaboratoryContract,
    saveTrialInstitutionLaboratoryContract,
    createTrialInstitutionLaboratoryContract,
    validateTrialInstitutionLaboratoryContract,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems,
    loadTrialInstitutionLaboratory,
    clearTrialInstitutionLaboratory
}) => {
    //
    // -- Params --
    const { trialId } = useParams<{ trialId: string }>();
    const { trialInstitutionId } = useParams<{ trialInstitutionId: string }>();
    const { trialInstitutionLaboratoryId } = useParams<{trialInstitutionLaboratoryId: string;}>();
    const { trialInstitutionLaboratoryContractId } = useParams<{trialInstitutionLaboratoryContractId: string;}>();
    const trialIdNumber = parseInt(trialId, 10);
    const trialInstitutionIdNumber = parseInt(trialInstitutionId, 10);
    const trialInstitutionLaboratoryIdNumber = parseInt(trialInstitutionLaboratoryId, 10);
    const trialInstitutionLaboratoryContractIdNumber = parseInt(trialInstitutionLaboratoryContractId, 10);

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [formInitalised, setFormInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    //
    // -- Hooks --
    const navigate = useNavigate();

    const loadReduxForm = () => {
        let extraData: Dtos.TrialInstitutionLaboratoryContract = {} as Dtos.TrialInstitutionLaboratoryContract;

        loadForm(
            reduxFormName,
            Object.assign({ ...trialInstitutionLaboratoryContract }, extraData)
        );
    };


    // Load Trial Institution Laboratory & Contract
    useEffect(() => {
        if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            trialInstitutionLaboratoryIdNumber &&
            trialInstitutionLaboratoryContractIdNumber &&
            !trialInstitutionLaboratoryContract &&
            !loadingTrialInstitutionLaboratoryContract
        ) {
            setBreadcrumbs(
                TrialInstitutionLaboratoryContractDetailsBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber,
                    trialInstitutionLaboratoryContractIdNumber
                )
            );

            loadTrialInstitutionLaboratoryContract(
                trialInstitutionLaboratoryContractIdNumber
            );
        } else if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            trialInstitutionLaboratoryIdNumber &&
            !trialInstitutionLaboratoryContractIdNumber &&
            !trialInstitutionLaboratoryContract &&
            !creatingTrialInstitutionLaboratoryContract
        ) {
            setBreadcrumbs(
                TrialInstitutionLaboratoryContractCreateBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber
                )
            );
            setDrawerItems([]);
            createTrialInstitutionLaboratoryContract(
                trialInstitutionLaboratoryIdNumber
            );
        } else if (trialInstitutionLaboratoryContract && !formInitalised) {
            loadReduxForm();
            setFormInitalised(true);
        }

        if (
            trialInstitutionLaboratoryIdNumber &&
            !trialInstitutionLaboratory &&
            !loadingTrialInstitutionLaboratory
        ) {
            loadTrialInstitutionLaboratory(trialInstitutionLaboratoryIdNumber);
        }
    }, [
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitutionLaboratoryIdNumber,
        trialInstitutionLaboratoryContractIdNumber,
        trialInstitutionLaboratoryContract,
        formInitalised,
        setDrawerItems,
        setBreadcrumbs,
        loadTrialInstitutionLaboratoryContract,
        trialInstitutionLaboratory,
        loadTrialInstitutionLaboratory,
        setFormInitalised,
        TrialInstitutionLaboratoryContractDetailsBreadcrumbs,
        TrialInstitutionLaboratoryContractCreateBreadcrumbs,
        createTrialInstitutionLaboratoryContract,
        loadReduxForm,
        loadingTrialInstitutionLaboratoryContract,
        creatingTrialInstitutionLaboratoryContract,
        loadingTrialInstitutionLaboratory,
    ]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadTrialInstitutionLaboratoryContractFailure) {
            navigate(`/error/${loadTrialInstitutionLaboratoryContractErrorCode}`);
        }
        if (loadTrialInstitutionLaboratoryFailure) {
            navigate(`/error/${loadTrialInstitutionLaboratoryErrorCode}`);
        }
    }, [
        loadTrialInstitutionLaboratoryContractFailure,
        loadTrialInstitutionLaboratoryFailure,
        loadTrialInstitutionLaboratoryContractErrorCode,
        loadTrialInstitutionLaboratoryErrorCode,
        navigate,
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            trialInstitutionLaboratoryIdNumber &&
            trialInstitutionLaboratoryContractIdNumber &&
            trialInstitutionLaboratoryContract &&
            trialInstitutionLaboratory
        ) {
            setDrawerItems(
                TrialInstitutionLaboratoryContractSubMenu(
                    trialInstitutionLaboratoryContract,
                    permissions
                )
            );
            setBreadcrumbs(
                TrialInstitutionLaboratoryContractDetailsBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber,
                    trialInstitutionLaboratoryContractIdNumber,
                    trialInstitutionLaboratory?.trialInstitution?.trial?.displayName,
                    trialInstitutionLaboratory?.trialInstitution?.institution?.name,
                    trialInstitutionLaboratory?.laboratory?.name,
                    trialInstitutionLaboratoryContract?.name
                )
            );
        } else if (
            trialIdNumber &&
            trialInstitutionLaboratoryIdNumber &&
            !trialInstitutionLaboratoryContractIdNumber &&
            trialInstitutionLaboratory
        ) {
            setBreadcrumbs(
                TrialInstitutionLaboratoryContractCreateBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber,
                    trialInstitutionLaboratory?.trialInstitution?.trial?.displayName,
                    trialInstitutionLaboratory?.trialInstitution?.institution?.name,
                    trialInstitutionLaboratory?.laboratory?.name
                )
            );
        }
    }, [
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitutionLaboratoryIdNumber,
        trialInstitutionLaboratoryContractIdNumber,
        trialInstitutionLaboratoryContract,
        trialInstitutionLaboratory,
        permissions,
        setDrawerItems,
        setBreadcrumbs,
        TrialInstitutionLaboratoryContractDetailsBreadcrumbs,
        TrialInstitutionLaboratoryContractCreateBreadcrumbs,
        TrialInstitutionLaboratoryContractSubMenu,
    ]);

    // Reload trial institution laboratory contract after saving
    useEffect(() => {
        if (
            !savingTrialInstitutionLaboratoryContract &&
            saveTrialInstitutionLaboratoryContractSuccess
        ) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Trial Institution Laboratory Contract saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate(
                    `/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/labs/${trialInstitutionLaboratoryIdNumber}/contracts`
                );
            } else if (!trialInstitutionLaboratoryContractIdNumber) {
                navigate(
                    `/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/labs/${trialInstitutionLaboratoryIdNumber}/contracts/${trialInstitutionLaboratoryContract?.id}/details`
                );
                clearTrialInstitutionLaboratoryContract();
            } else {
                loadTrialInstitutionLaboratoryContract(trialInstitutionLaboratoryContractIdNumber);
            }
        }
    }, [
        savingTrialInstitutionLaboratoryContract,
        saveTrialInstitutionLaboratoryContractSuccess,
        loadTrialInstitutionLaboratoryContract,
        trialInstitutionLaboratoryContractIdNumber,
        navigate,
        saveAndReturn,
        clearTrialInstitutionLaboratoryContract,
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitutionLaboratoryIdNumber,
        trialInstitutionLaboratoryContract,
    ]);

    // Failed saving
    useEffect(() => {
        if (
            !savingTrialInstitutionLaboratoryContract &&
            saveTrialInstitutionLaboratoryContractFailure
        ) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [
        savingTrialInstitutionLaboratoryContract,
        saveTrialInstitutionLaboratoryContractSuccess,
        loadTrialInstitutionLaboratoryContract,
        trialInstitutionLaboratoryContractIdNumber,
    ]);

    // Cleanup effect to clear the trial institution laboratory & contract on component unmount
    useEffect(() => {
        return () => {
            clearTrialInstitutionLaboratoryContract();
            clearTrialInstitutionLaboratory();
            resetForm(reduxFormName);
        };
    }, [
        clearTrialInstitutionLaboratoryContract,
        clearTrialInstitutionLaboratory,
        resetForm,
        reduxFormName,
    ]);

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.TrialInstitutionLaboratoryContract = {} as Dtos.TrialInstitutionLaboratoryContract;

            if (!data.trialInstitutionLaboratoryId) {
                changes.trialInstitutionLaboratoryId = trialInstitutionLaboratoryIdNumber;
            }

            await saveTrialInstitutionLaboratoryContract(
                Object.assign({ ...data }, changes)
            );

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    const handleOnSubmitFailed = (_data: Dtos.TrialInstitutionLaboratoryContract) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const onCancel = () => {
        navigate(`/trials/${trialIdNumber}/trialinstitution/${trialInstitutionLaboratoryIdNumber}/labs/${trialInstitutionLaboratoryIdNumber}/contracts`);
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.TrialInstitutionLaboratoryContract = {} as Dtos.TrialInstitutionLaboratoryContract;

            if (
                form &&
                hasBeenSubmitted &&
                !validatingTrialInstitutionLaboratoryContract
            ) {
                await validateTrialInstitutionLaboratoryContract(
                    Object.assign({ ...form }, changes)
                );
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const openLink = (link: string) => {
        window.open(`${link}`, "_blank");
        return null;
    };

    const renderContent = useMemo(() => {
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermissionFor(
                undefined,
                trialInstitutionLaboratoryContractIdNumber,
                permissions,
                Dtos.Permission.TrialInstitutionLaboratoryContractUpdate,
                Dtos.Permission.TrialInstitutionLaboratoryContractCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingTrialInstitutionLaboratoryContract ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <div className="card card-shadow" style={{ zIndex: 1 }}>
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratoryContract",
                                        {
                                            name: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-12 col-xl-2",
                                                fieldClassName: "col-sm-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratoryContract",
                                        {
                                            location: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    addOnRightButton: (
                                                        <button
                                                            className="btn btn-secondary"
                                                            type="button"
                                                            id="button-addon2"
                                                            disabled={form?.location == null || !isUrl(form?.location)}
                                                            style={{
                                                                cursor: form?.location == null || !isUrl(form?.location)
                                                                        ? "not-allowed"
                                                                        : "pointer",
                                                                padding: "4px 10px",
                                                            }}
                                                            onClick={() => {
                                                                openLink(form.location);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={FontAwesomeIcons.Duotone.ARROWUPRIGHTFROMSQUARE} />
                                                        </button>
                                                    ),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-12 col-xl-2",
                                                fieldClassName: "col-sm-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratoryContract",
                                        {
                                            dateSentToSite: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-12 col-xl-4",
                                                fieldClassName: "col-sm-12 col-xl-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratoryContract",
                                        {
                                            dateConfirmedBySite: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-12 col-xl-4",
                                                fieldClassName: "col-sm-12 col-xl-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Details</h1>
                    </div>
                    <div
                        className="col d-flex justify-content-end align-items-stretch"
                        style={{ height: "38px" }}
                    >
                        {/* {(AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabView) && trialInstitutionLaboratoryContractIdNumber) ? (
                            <Link 
                                className={"btn btn-primary"} 
                                url={`/labs/${trialInstitutionLaboratoryContract?.laboratoryId}/details`}
                                target='_blank'
                            >
                                {`Primary  `}
                                <FontAwesomeIcon icon={FontAwesomeIcons.Duotone.ARROWUPRIGHTFROMSQUARE} />
                            </Link>
                        ) : null} */}
                    </div>
                </div>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => handleOnSubmit(val)}
                    onSubmitFailed={(val) => handleOnSubmitFailed(val)}
                >
                    {renderFormControls(
                        form,
                        "trialInstitutionLaboratoryContract",
                        formComponents,
                        lookups,
                        validationFailures,
                        formProperties,
                        changeForm
                    )}
                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(reduxFormName + ".saveAndReturn", false);
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(reduxFormName + ".saveAndReturn", true);
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={onCancel}
                            className="btn btn-primary mr-2"
                        >
                            Cancel
                        </button>
                    </div>
                </Form>
            </>
        );
    }, [
        AuthenticationHelper,
        trialInstitutionLaboratoryContractIdNumber,
        permissions,
        savingTrialInstitutionLaboratoryContract,
        formState,
        handleOnSubmit,
        handleOnSubmitFailed,
        renderFormControls,
        lookups,
        validationFailures,
        formProperties,
        form,
        changeForm,
        reduxFormName,
        onCancel,
        trialInstitutionLaboratory,
        trialInstitutionLaboratoryContract,
    ]);

    return (
        <RestrictedLayout
            permission={Dtos.Permission.TrialInstitutionLaboratoryContractView}
            loading={
                loadingTrialInstitutionLaboratoryContract ||
                creatingTrialInstitutionLaboratoryContract ||
                savingTrialInstitutionLaboratoryContract
            }
        >
            {renderContent}
        </RestrictedLayout>
    );
};

const mapStateToProps = (
    state: ITmdState
): Partial<TrialInstitutionLaboratoryContractPageProps> => {
    let trialInstitutionLaboratoryContract:
        | Dtos.TrialInstitutionLaboratoryContract
        | undefined = !(
        state.trialInstitutionLaboratoryContract.formData instanceof Array
    )
        ? state.trialInstitutionLaboratoryContract.formData
        : undefined;
    let trialInstitutionLaboratory:
        | Dtos.TrialInstitutionLaboratory
        | undefined = !(
        state.trialInstitutionLaboratory.formData instanceof Array
    )
        ? state.trialInstitutionLaboratory.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        trialInstitutionLaboratoryContract: trialInstitutionLaboratoryContract!,
        loadingTrialInstitutionLaboratoryContract: state.trialInstitutionLaboratoryContract.loadState && state.trialInstitutionLaboratoryContract.loadState.status == RequestState.Pending,
        loadTrialInstitutionLaboratoryContractSuccess: state.trialInstitutionLaboratoryContract.loadState && state.trialInstitutionLaboratoryContract.loadState.status == RequestState.Success,
        loadTrialInstitutionLaboratoryContractFailure: state.trialInstitutionLaboratoryContract.loadState && state.trialInstitutionLaboratoryContract.loadState.status == RequestState.Failure,
        loadTrialInstitutionLaboratoryContractErrorCode: state.trialInstitutionLaboratoryContract.loadState.errorCode,
        savingTrialInstitutionLaboratoryContract: state.trialInstitutionLaboratoryContract.saveState && state.trialInstitutionLaboratoryContract.saveState.status == RequestState.Pending,
        saveTrialInstitutionLaboratoryContractSuccess: state.trialInstitutionLaboratoryContract.saveState && state.trialInstitutionLaboratoryContract.saveState.status == RequestState.Success,
        saveTrialInstitutionLaboratoryContractFailure: state.trialInstitutionLaboratoryContract.saveState && state.trialInstitutionLaboratoryContract.saveState.status == RequestState.Failure,
        creatingTrialInstitutionLaboratoryContract: state.trialInstitutionLaboratoryContract.createState && state.trialInstitutionLaboratoryContract.createState.status == RequestState.Pending,
        createTrialInstitutionLaboratoryContractSuccess: state.trialInstitutionLaboratoryContract.createState && state.trialInstitutionLaboratoryContract.createState.status == RequestState.Success,
        createTrialInstitutionLaboratoryContractFailure: state.trialInstitutionLaboratoryContract.createState && state.trialInstitutionLaboratoryContract.createState.status == RequestState.Failure,
        validatingTrialInstitutionLaboratoryContract: state.trialInstitutionLaboratoryContract.validateState && state.trialInstitutionLaboratoryContract.validateState.status == RequestState.Pending,
        user: state.user.data,
        permissions: permissions,
        lookups: state.trialInstitutionLaboratoryContract.lookups,
        form: state.reduxForms.trialInstitutionLaboratoryContract,
        formState: state.trialInstitutionLaboratoryContract.formState,
        formProperties: state.trialInstitutionLaboratoryContract.formProperties,
        reduxFormState: state.reduxForms.formState.trialInstitutionLaboratoryContract,
        validationFailures: trialInstitutionLaboratoryContract
            ? state.trialInstitutionLaboratoryContract.validationFailures
            : undefined,
        trialInstitutionLaboratory: trialInstitutionLaboratory!,
        loadingTrialInstitutionLaboratory: state.trialInstitutionLaboratory.loadState && state.trialInstitutionLaboratory.loadState.status == RequestState.Pending,
        loadTrialInstitutionLaboratorySuccess: state.trialInstitutionLaboratory.loadState && state.trialInstitutionLaboratory.loadState.status == RequestState.Success,
        loadTrialInstitutionLaboratoryFailure: state.trialInstitutionLaboratory.loadState && state.trialInstitutionLaboratory.loadState.status == RequestState.Failure,
        loadTrialInstitutionLaboratoryErrorCode: state.trialInstitutionLaboratory.loadState.errorCode,
    };
};

const mapDispatchToProps = (
    dispatch
): Partial<TrialInstitutionLaboratoryContractPageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),
        loadTrialInstitutionLaboratoryContract: bindActionCreators(TrialInstitutionLaboratoryContractActions.LoadTrialInstitutionLaboratoryContractById, dispatch),
        clearTrialInstitutionLaboratoryContract: bindActionCreators(TrialInstitutionLaboratoryContractActions.Clear, dispatch),
        saveTrialInstitutionLaboratoryContract: bindActionCreators(TrialInstitutionLaboratoryContractActions.SaveTrialInstitutionLaboratoryContract, dispatch),
        createTrialInstitutionLaboratoryContract: bindActionCreators(TrialInstitutionLaboratoryContractActions.CreateTrialInstitutionLaboratoryContract, dispatch),
        validateTrialInstitutionLaboratoryContract: bindActionCreators(TrialInstitutionLaboratoryContractActions.ValidateTrialInstitutionLaboratoryContract, dispatch),
        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch),
        loadTrialInstitutionLaboratory: bindActionCreators(TrialInstitutionLaboratoryActions.LoadTrialInstitutionLaboratoryById, dispatch),
        clearTrialInstitutionLaboratory: bindActionCreators(TrialInstitutionLaboratoryActions.Clear, dispatch)
    };
};

export default connect(mapStateToProps,  mapDispatchToProps)(TrialInstitutionLaboratoryContractPage);
